import React from 'react';
import { CheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, productShortName } from '../data/offer';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access'];
export function FinalCta() {
  return <section className="border-t border-electric/10 bg-navy py-16 sm:py-20" aria-labelledby="final-title" data-id="element-57" data-mp="19cmbicot9re1">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-58" data-mp="1jd53juqj4e71">
        <h2 id="final-title" className="inline-flex items-center gap-2 text-balance text-3xl font-bold tracking-tight text-white sm:text-4xl" data-id="element-59" data-mp="1jbk6nygqsj60">
          <ZapIcon className="h-7 w-7 shrink-0 text-gold" aria-hidden="true" data-id="element-60" data-mp="1t2yaujjn275h" /> {productShortName}
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-ink" data-id="element-61" data-mp="1o43hino1p074">
          Created by electrical engineering education specialists, for educators worldwide.
        </p>

        <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-8 w-full sm:w-auto" data-id="element-62" data-mp="1x4jnq4w6alfo">
          Get my teacher ready now
        </Button>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-ink" data-id="element-63" data-mp="n7fdpjpo0sax">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-64" data-mp="x3sa4pclhk9d">
              <CheckIcon className="h-4 w-4 text-electric" aria-hidden="true" data-id="element-65" data-mp="x5v8bwnwijp6" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}